// components/ApplicationSuccessModal.jsx
import { Switch } from "@mui/material";
import React from "react";
import { IoClose } from "react-icons/io5";

const ApplicationSuccessModal = ({ job, onClose }) => {
  if (!job) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 px-4">
      <div className="bg-white w-full max-w-3xl rounded-md shadow-lg overflow-y-auto max-h-[90vh] relative p-6">
        {/* Header */}
        <button onClick={onClose} className="absolute right-4 top-4 text-gray-400 hover:text-black">
          <IoClose size={22} />
        </button>

        <div className="text-xs text-gray-600 mb-2">Applying to</div>
        <div className="font-semibold text-sm ">{job.title}</div>
        <div className="text-xs text-gray-500 mb-6">{job.company} in {job.location}</div>

        {/* Main Message */}
        <h2 className="text-xl font-semibold mb-4 text-black">
          Congrats! You’ve successfully applied and created a profile!
        </h2>
        <p className="text-sm text-gray-700 mb-4">
          This profile will be viewed by employers with your application. It can also be viewed by employers on
          ZipRecruiter who are searching for candidates like you! Keep this profile up-to-date to improve your chances of
          getting hired.
        </p>
        <p className="text-sm text-gray-700 mb-6">
          Click <span className="font-semibold">edit</span> to make any necessary updates to your profile. You can also
          change your privacy settings below. If you like what you see, please <span className="font-semibold">continue</span>.
        </p>

        {/* Action Buttons */}
        <div className="flex gap-4 mb-6">
          <button className="border border-black px-6 py-2 rounded font-semibold text-sm">Edit</button>
          <button className="bg-black text-white px-6 py-2 rounded font-semibold text-sm">Continue</button>
        </div>

        {/* Visibility Switch */}
        <div className="mb-6 border rounded px-4 py-3">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-black mb-1">Let Employers Find You</p>
              <p className="text-xs text-gray-600 max-w-sm">
                Public: Hiring managers will be able to view your profile and reach out about potential opportunities.
              </p>
            </div>
            <Switch
              checked={true}
              className="relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full  transition"
            >
              <span className="sr-only">Enable</span>
              <span className="inline-block h-4 w-4 translate-x-5 transform rounded-full bg-white transition" />
            </Switch>
          </div>
        </div>

        {/* Profile Summary */}
        <div className="grid sm:grid-cols-2 gap-6 text-sm">
          <div>
            <p className="font-semibold">kelly muller</p>
            <p className="text-gray-600">Toronto, ON Canada</p>
            <div className="mt-3">
              <p className="font-semibold text-xs text-gray-700 mb-1">Experience</p>
              <p className="text-gray-700 text-sm">Scaffolding and Swing Stages</p>
              <p className="text-gray-700 text-sm">Installer</p>
              <p className="text-gray-700 text-sm">General Carpentry</p>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-xs text-gray-700 mb-1">Education</p>
              <p className="text-gray-700 text-sm">-</p>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-xs text-gray-700 mb-1">Desired Salary</p>
              <p className="text-gray-700 text-sm">$80,000 / year</p>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-xs text-gray-700 mb-1">Country</p>
              <p className="text-gray-700 text-sm">Canada</p>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-xs text-gray-700 mb-1">Contact Information</p>
              <p className="text-gray-700 text-sm">kmuller1690@gmail.com</p>
              <p className="text-gray-700 text-sm">+1 705-808-0875</p>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-xs text-gray-700 mb-1">Skills</p>
              <div className="flex flex-wrap gap-2 mt-1">
                {["Assembly Line", "Blueprint Reading", "Budget Management", "Cabinet Making", "Carpentry", "Collaboration", "Concrete Work"].map(skill => (
                  <span key={skill} className="bg-gray-200 text-xs rounded-full px-3 py-1">{skill}</span>
                ))}
              </div>
            </div>
          </div>

          <div>
            <p className="font-semibold text-xs text-gray-700 mb-1">Executive Summary</p>
            <p className="text-sm text-gray-700">
              Reliable and hardworking Construction and Carpentry Professional with over 10 years of hands-on experience in residential,
              commercial, and renovation projects. Skilled in a wide range of carpentry techniques with a strong focus on quality craftsmanship...
            </p>
            <p className="text-[#004349] text-sm font-semibold cursor-pointer mt-2">show more</p>

            <div className="mt-6">
              <p className="font-semibold text-xs text-gray-700 mb-2">Experience</p>
              <div className="text-sm text-gray-800 space-y-3">
                <div>
                  <p className="font-semibold">Scaffolding and Swing Stages</p>
                  <p className="text-xs text-gray-500">Aluma Safway • Jul 2024 – Oct 2024</p>
                </div>
                <div>
                  <p className="font-semibold">Scaffolder</p>
                  <p className="text-xs text-gray-500">Oxford Building Supplies • Apr 2024 – May 2024</p>
                </div>
                <div>
                  <p className="font-semibold">Installer</p>
                  <p className="text-xs text-gray-500">Architectural Millwork & Door Installations • Nov 2022 – Sep 2023</p>
                </div>
                <div>
                  <p className="font-semibold">General Carpentry</p>
                  <p className="text-xs text-gray-500">Cirrus Management • Jun 2022 – Sep 2022</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSuccessModal;
